export default __webpack_public_path__ + "static/media/tax.687ba951.svg";